import { SPRING_CONFIG_SNAPPY } from '#pplx/frontend/aether/config.js';
import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
import { useSpring } from '@react-spring/web';
import { useCallback, useRef } from 'react';
export const SECTION_CONTENT_WRAPPER_PADDING_Y_PX = 16;
export function useAnimatedSectionCollapse(expanded, animationKey) {
    const shouldAnimate = useRef(false);
    const prevExpanded = useRef(expanded);
    const prevAnimationKey = useRef(animationKey);
    if (prevExpanded.current !== expanded || prevAnimationKey.current !== animationKey) {
        shouldAnimate.current = true;
        prevExpanded.current = expanded;
        prevAnimationKey.current = animationKey;
    }
    const { progress } = useSpring({
        progress: expanded ? 1 : 0,
        config: { ...SPRING_CONFIG_SNAPPY, clamp: true },
        immediate: !shouldAnimate.current,
        onRest: () => (shouldAnimate.current = false),
    });
    return {
        progress,
        shouldAnimate: shouldAnimate.current,
    };
}
export function usePersistedSidebarListCollapsed(collapseSettingsKey, defaultExpanded = true) {
    const [expanded, setExpanded] = useLocalUserSettings(collapseSettingsKey, defaultExpanded);
    const toggleCollapsed = useCallback(() => setExpanded((prev) => !prev), [setExpanded]);
    const expand = useCallback(() => setExpanded(true), [setExpanded]);
    return [!expanded, toggleCollapsed, expand];
}
//# sourceMappingURL=SectionShared.js.map